import React, { Suspense, useRef, useState } from "react";
import { Canvas, extend, useThree, useFrame } from "react-three-fiber";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

import { Loader } from "./Loader";
import Box from "../3D_components/simpleBox";
import FixedLabel from "../3D_components/fixedLabel";
// import settings from "./configs/fady.config";

// const { controlsSettings, cameraSettings } = settings;

extend({ OrbitControls });

const Controls = ({ settings }) => {
  const orbitRef = useRef();
  const { camera, gl } = useThree();
  useFrame(() => {
    orbitRef.current.update();
  });

  return (
    <orbitControls
      ref={orbitRef}
      // autoRotate
      args={[camera, gl.domElement]}
      maxPolarAngle={settings.maxPolarAngle}
      minPolarAngle={settings.minPolarAngle}
      maxDistance={settings.maxDistance}
      minDistance={settings.minDistance}
    />
  );
};

const Scene = ({ controlsSettings, cameraSettings, models }) => {
  const [labelContent, setLabelContent] = useState("")
  const onLabelUpdate = newLabel => setLabelContent(newLabel)
  return (
    <div className="App">
      <FixedLabel text={labelContent} />
      <Canvas
        colorManagement={false}
        style={{
          width: window.innerWidth,
          height: window.innerHeight,
          position: "fixed",
        }}
        gl={{ alpha: false }}
        camera={cameraSettings}
        onCreated={({ gl, camera }) => {
          camera.lookAt(0, 0, 0);
          gl.setClearColor("#fff");
        }}
        shadowMap
      >
        <pointLight position={[100, 200, 0]} intensity={0.5} />
        <ambientLight intensity={0.25} />
        <directionalLight
          color={"white"}
          intensity={0.7}
          position={[10, 20, 10]}
          shadow-mapSize-width={4096}
          shadow-mapSize-height={4096}
          shadow-camera-left={-40}
          shadow-camera-right={40}
          shadow-camera-top={40}
          shadow-camera-bottom={-40}
          // castShadow
        />
        <Suspense fallback={<Box position={[0, 0, 0]}></Box>}>
          {models.map((M, idx) => (
            <M.jsx src={M.src} key={`model=${idx}`} onPointerLabelCallback={onLabelUpdate}/>
          ))}
        </Suspense>
        <Controls settings={controlsSettings} />
      </Canvas>
      <Loader />
    </div>
  );
};

export default Scene;
